import { Marketing } from "./Marketing.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  Marketing
};
//# sourceMappingURL=index.js.map
